export default "__VITE_ASSET__0299eed5__"